import { type ReactNode } from "react";

import { AutoScaler } from "@/components/ui/AutoScaler/AutoScaler";

type ScaledIframeProps = {
  src: string;
  desiredWidth: number;
  title?: string;
  className?: string;
  placeholder?: ReactNode;
};

export function ScaledIframe({
  src,
  desiredWidth,
  title = "Scaled Iframe",
  className,
  placeholder,
}: ScaledIframeProps) {
  return (
    <div className="relative size-full">
      <div className="absolute inset-0 z-0">{placeholder}</div>
      <div className="relative z-[1] size-full">
        <AutoScaler
          desiredWidth={desiredWidth}
          className={className}
          placeholder={placeholder}
        >
          <iframe
            src={src}
            className="size-full border-0"
            style={{
              overflow: "hidden",
              display: "block",
            }}
            scrolling="no"
            title={title}
          />
        </AutoScaler>
      </div>
    </div>
  );
}
